/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

// usage note: read checked attribute on input/checkbox to assess if selected or not

export const Checkbox = ({ id, defaultChecked, disabled, onChange, checked, label, className, labelClassName }) => {
  const inputId = id || Math.floor(Math.random() * 1000)

  return (
    <div className={`slds-form-element ${className}`}>
      <div className='slds-form-element__control'>
        <span className='slds-checkbox'>
          <input
            type='checkbox'
            name='options'
            id={`checkbox-${inputId}`}
            defaultChecked={defaultChecked}
            disabled={disabled}
            onChange={onChange}
            checked={checked}
          />
          <label className='slds-checkbox__label' htmlFor={`checkbox-${inputId}`}>
            {label === ''
              ? <span className='slds-checkbox_faux' style={{ marginRight: 0 }}></span>
              : <span className='slds-checkbox_faux'></span> // also sets small margin to right of checkbox
            }
            <span className={`slds-form-element__label ${labelClassName}`}>
              {label}
            </span>
          </label>
        </span>
      </div>
    </div>
  )
}

Checkbox.defaultProps = {
  label: '',
  className: '',
  labelClassName: ''
}

Checkbox.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  defaultChecked: PropTypes.bool,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  labelClassName: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/checkbox/index.js